window.App = {};

App.showSearch = function () {
	$('[data-action="open-search"]').on('click', function (e) {
		$('.searchbar').show().find('.form-control').focus();
		e.preventDefault();
	});

	$('[data-action="close-search"]').on('click', function (e) {
		$('.searchbar').hide();
		e.preventDefault();
	});

	// click outside search and open search
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.searchbar').length && !$(e.target).closest('[data-action="open-search"]').length) {
            $('.searchbar').hide();
        }
    });
};

App.search_Move = function () {
	let move_div = $('.app-header .bottom .searchbar');
	let where = $('.app-header .top .container');
	if($(window).width() < 768) {
		$('<div class="searchbar">' + move_div.html() + '</div>').insertAfter(where);

		App.showSearch();
	}
}

App.menu = function () {
	$("#menu").mmenu({
		navbar: {
			add: false
		},
		"extensions": [
			"position-right",
			"pagedim-white",
			"position-front"
		]
	}, {
		offCanvas: {
			pageSelector: '.app-wrapper'
		}
	});

	$('*[data-action="open-menu"]').click(function (e) {
		var api = $("#menu").data("mmenu");
		api.open();
		//Menu and header sticky fix
		setTimeout(function(){ 
			$('.app-header').removeAttr('style');
			$('.middle').removeClass('sticky');
		}, 250);

		e.preventDefault();
	});

	$('#menu .close').click(function (e) {
		var api = $("#menu").data("mmenu");
		api.close();

		e.preventDefault();
	});
}

App.weather = function () {
	var active_weather = $('.weather>ul.cities>li.active');
	$('.weather>span.name').html(active_weather.text() + ' &nbsp;' + active_weather.attr('data-degree'));
	$('.weather>span.icon').addClass(active_weather.attr('data-icon'));

	$('.weather').click(function () {
		$(this).children('ul.cities').slideToggle('fast');
	});
	$('.weather>ul.cities>li').click(function () {
		$('.weather>span.name').html($(this).text() + ' &nbsp;' + $(this).attr('data-degree'));
		//
		$('.weather>span.icon').removeClass(active_weather.attr('data-icon'));
		//
		$('.weather>ul.cities>li').removeClass('active');
		$(this).addClass('active');
		//
		active_weather = $('.weather>ul.cities>li.active');
		$('.weather>span.icon').addClass(active_weather.attr('data-icon'));
	});
}

App.fontSize = function () {
	var font_i = 2;
	var news_content = $(".content-detail .content-text");
	var default_font = parseInt(news_content.css("font-size"));
	$('.text-sizes').click(function (event) {
		event.preventDefault();
		//
		var font_size = default_font + font_i;
		news_content.animate({
			"font-size": font_size
		});
		//
		font_i += 2;

		if (font_size >= 25) {
			font_i = 2;
			font_size = default_font;
		}
	});
}

App.towers = function() {
    var container = $('.ad-tower-container');
    if(container.length > 0) {
        var navPositionTop = $('.app-header').height();
        var adLeft = $('.ad-tower-container .ad-left');
        var adRight = $('.ad-tower-container .ad-right');
        var scrollTop = $(window).scrollTop();

        if(scrollTop >= navPositionTop) {
            adLeft.css('top', - navPositionTop+20);
            adRight.css('top', - navPositionTop+20);
        }

        $(window).scroll(function() {
			scrollTop = $(window).scrollTop();
			navPositionTop = $('.app-header').height()+20;

            if(scrollTop >= navPositionTop) {
                adLeft.css('top', 0);
                adRight.css('top', 0);
            } else {
                adLeft.css('top', - navPositionTop);
                adRight.css('top', - scrollTop);
            }
        });
    }
};

App.count = 1;
App.loadHomePage = false;

App.infinityInit = function (options) {

	var defaults = {
		change: function (elm) {
		},
		success: function (elm) {
		},
		position: 'bottom',
		item: '.infinity-item',
		loadHomePage: false,
	};

	options = Object.assign({}, defaults, options);

	//referrer eğer ki dolu ise ve paradurumu domaini üzerinden gelmiyor ise

	if (window.document.referrer.length > 0 && !window.document.referrer.includes('paradurumu.com')) {
		App.loadHomePage = true;
	}

	$('#infinity-container').infinity({
		item: options.item,
		isAjax: true,
		postscribe: false,
		loadingText: '<div class="d-flex justify-content-center mb-20"><div class="infinity-loader"><div class="preloader4"></div> Yükleniyor...</div></div>',
		timeOut: 1,
		analytics: true,
		position: options.position,
		promotePosts: options.promotePosts,
		promotePostType: options.promotePostType,
		onHistoryChange: function (elm) {
			options.change(elm);
		},
		onBeforeAjax: function(){
			if (App.count+1 > 1 && App.loadHomePage && options.loadHomePage) {
					return true;
			}
		},
		onAjaxSuccess: function (elm) {
			App.count++;

			options.success(elm);
			lozad().observe();
		}
	});
};

App.contentSideOutStreamAdv = function() {
	let contentSideParagraph = $(".content-detail .news-content-side .content-text>p");
	let paragraphCount = contentSideParagraph.length;

	if(paragraphCount > 0) {
		setTimeout(function(){
			//let i = parseInt(paragraphCount / 2);
			let i = 1;
			contentSideParagraph.parent().children().eq(i).after('<div id="adpro_1525" class="adpro text-center" data-page="307" data-region="1525" data-category="-1"></div>');
			//
			let isFirstRun = true;
			function handler(entries, observer) {
				for (entry of entries) {
					if(isFirstRun && entry.isIntersecting) {
						adpro.loadAds('adpro_1525');
						//
						isFirstRun = false;
						//
						console.log('Outstream');
					}
				}
			}
			let observer = new IntersectionObserver(handler);
			observer.observe(document.getElementById("adpro_1525"));
		}, 2000);
	}
};

App.poll = function() {

	let el = $('section.poll');

	if (el.length > 0) {
		el.find('.bttn.results').on('click', function(e) {
			console.log('results');
			e.preventDefault();
			$(this).addClass('d-none');
			el.find('div.options:not(.d-none)').addClass('d-none');
			el.find('.bttn.options').removeClass('d-none');
			el.find('div.results').removeClass('d-none');
		});
		el.find('.bttn.options').on('click', function(e) {
			console.log('options', el.find('div.options'));
			e.preventDefault();
			$(this).addClass('d-none');
			el.find('div.results:not(.d-none)').addClass('d-none');
			el.find('.bttn.results').removeClass('d-none');
			el.find('div.options').removeClass('d-none');
		});
	}

}

App.loadMoreComments = function() {
	$(document).on('click', '.comments .load-more-comments', function(e) {
        $('.comments .comments_item.d-none').slice(0, 5).removeClass('d-none');
        if($('.comments .comments_item.d-none').length == 0) {
            $(this).addClass('d-none');
        }
    });
}

App.productionBuildVersion = function() {
    // Production version change    
};


// WEBPACK FOOTER //
// ./resources/assets/web/scripts/app.js